<template>
  <div class="flex items-center gap-2">
    <button
      class="hover:underline"
      :class="{ 'font-bold': currentLocale === 'uk' }"
      @click="$store.dispatch('locale/SET_LOCALE', 'uk')"
    >
      🇺🇦 {{ $t('language.ukrainian') }}
    </button>
    <span class="text-[#DCDCDC]">|</span>
    <button
      class="hover:underline"
      :class="{ 'font-bold': currentLocale === 'en' }"
      @click="$store.dispatch('locale/SET_LOCALE', 'en')"
    >
      🇺🇸 {{ $t('language.english') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseLanguageSwitch',

  computed: {
    ...mapGetters('locale', ['currentLocale'])
  }
}
</script>
